import { useI18next, useTranslation } from 'gatsby-plugin-react-i18next';
import { getOriginalLocale } from '@helpers/GlobalHelpers';
import { useMemo } from 'react';
import { generateLinkWithExternalParams } from '../helpers/linkHelpers';

const lookupQuerystring = 'lng';

const useLocale = () => {
    const { i18n } = useTranslation();
    const { language } = useI18next();

    const getApySrc = () => {
        if (typeof window !== 'undefined') {
            const array = window.location.search.replaceAll('?', '').split('&');
            let res;
            array.forEach((str) => {
                const strArray = str.split('=');
                const apySrcIndex = strArray.indexOf('apy_src');

                if (apySrcIndex >= 0) {
                    res = strArray[apySrcIndex + 1];
                }
            });

            return res;
        }
        return undefined;
    };

    const currentLanguage = useMemo(() => getOriginalLocale(language), [
        language,
    ]);

    const getAppLinkWithCurrentLang = (url) => {
        const apySrc = getApySrc();
        const fullUrl =
            url?.split('?').length > 1
                ? `${url}&${lookupQuerystring}=${i18n.language}`
                : `${url}?${lookupQuerystring}=${i18n.language}`;
        return generateLinkWithExternalParams(fullUrl, apySrc);
    };

    const getContentFromLanguage = (data) => {
        return data[currentLanguage];
    };

    const routeAppLocaleToCmsLocale = (locale?: string) => {
        if (!locale) return "de-CH";
        switch (locale) {
          case "en":
            return "en";
          case "fr":
            return "fr-CH";
          case "it":
            return "it";
          default:
            return "de-CH"; // fallback to default language
        }
      };

      const routeCmsLocaleToAppLocale = (locale?: string) => {
        if (!locale) return "de";
        switch (locale) {
          case "en":
            return "en";
          case "fr-CH":
            return "fr";
          case "it":
            return "it";
          default:
            return "de"; // fallback to default language
        }
      };

    return {
        getAppLinkWithCurrentLang,
        getContentFromLanguage,
        currentLanguage,
        routeAppLocaleToCmsLocale,
        routeCmsLocaleToAppLocale
    };
};

export default useLocale;
